(function () {
  let callbackMap = {}
  let u = navigator.userAgent
  console.log("userAgent",u)
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  let getNextMsgId = (method) => {
    return method + new Date().getTime()
  }

  function executeMobile (method, params, callback) {
    let data = {
      callbackId: null,
      params: params
    }

    if (callback) {
      let callbackId = getNextMsgId(method)
      data.callbackId = callbackId
      callbackMap[callbackId] = callback
    }
    console.log("isAndroid",isAndroid)
    if (isAndroid) {
      return window.$android.native(method, JSON.stringify(data))
    } else if (isIOS) {
      return window.webkit.messageHandlers[method].postMessage(JSON.stringify(data))
    }
  }
  window.$mobile = {}
  window.$mobile.callback = function (params) {
    let id = params.callbackId
    let callback = callbackMap[id]
    if (callback) {
      delete callbackMap[id]
      callback(params.params)
    }
  }
  window.$mobile.login = (callback) =>  executeMobile('login',null,callback)
  window.$mobile.showMeiQia = () =>  executeMobile('showMeiQia')
})()
